"use client";

import { useClickOutside } from "@repo/lib/hooks/common";
import { Link } from "@/i18n/routing";
import { IconAccountProfile, IconAccountWishlist, IconAvatar, IconForwardArrowBlack, IconPolygon } from "@repo/assets/images";
import { CMS_LINKS } from "@repo/constants/common";
import { BottomSheet, Button } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useCallback, useRef, useState } from "react";
const UserDropdown = ({
  session
}) => {
  const t = useTranslations("Common");
  const [isOpen, setIsOpen] = useState(false);
  const [isUserDropdownBottomSheetOpen, setIsUserDropdownBottomSheetOpen] = useState(false);
  const dropdownRef = useRef();
  const DropdownContent = ({
    onClick
  }) => {
    return <div className={cx("end-0 z-50 -mx-4 mt-2 origin-top-right overflow-hidden bg-white md:absolute md:mx-0 md:w-80 md:shadow-lg md:ring-1 md:ring-black md:ring-opacity-5 rtl:md:w-80", {
      "hidden md:block": isOpen
    })} data-sentry-component="DropdownContent" data-sentry-source-file="UserDropdown.jsx">
        {!session && <div className="border-lightgray grid grid-cols-2 space-x-4 border-b p-4 rtl:space-x-reverse">
            <Link href="/login" onClick={onClick}>
              <Button size="md" variant="primary" className="w-full border border-black font-semibold">
                {t("Login")}
              </Button>
            </Link>
            <Link href="/register" onClick={onClick}>
              <Button size="md" variant="secondary" className="w-full font-semibold">
                {t("Register")}
              </Button>
            </Link>
          </div>}
        <>
          {session && <Link className="border-supportiveDarkGray text-supportiveBlack hover:text-supportiveBlack hover:bg-icon-bg flex w-full items-center border-b p-4 text-left text-base font-medium" href="/account" onClick={onClick}>
              <IconAccountProfile className="me-2 fill-current" />
              {t("Account")}
              <IconForwardArrowBlack className="ms-auto fill-current rtl:rotate-180" />
            </Link>}
          {!session && <Link className="border-supportiveDarkGray text-supportiveBlack hover:text-supportiveBlack hover:bg-icon-bg flex w-full items-center border-b p-4 text-left text-base font-medium" href="/favourites" onClick={onClick}>
              <IconAccountWishlist className="me-2 fill-current" />
              {t("Favourites")}
              <IconForwardArrowBlack className="ms-auto fill-current rtl:rotate-180" />
            </Link>}
          <div className="divide-supportiveDarkGray border-supportiveDarkGray divide-y border-b md:border-b-0">
            {CMS_LINKS?.map(option => {
            // Links to show if customer is logged in
            const IconComponent = option.icon;
            return <Link key={option.id} onClick={onClick} href={option?.url} className="text-supportiveBlack hover:text-supportiveBlack hover:bg-icon-bg flex w-full items-center p-4 text-left text-base font-medium">
                  <IconComponent className="me-2 fill-current" />
                  {t(option.label)}
                  <IconForwardArrowBlack className="ms-auto fill-current rtl:rotate-180" />
                </Link>;
          })}
          </div>
        </>
      </div>;
  };
  const handleDropdown = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);
  const handleCloseDropdown = useCallback(() => {
    setIsOpen(false);
  }, []);
  const handleUserDropdownBottomSheet = () => {
    setIsUserDropdownBottomSheetOpen(!isUserDropdownBottomSheetOpen);
  };
  useClickOutside(dropdownRef, handleCloseDropdown);
  return <div className="relative inline-block px-2 md:ps-2" data-sentry-component="UserDropdown" data-sentry-source-file="UserDropdown.jsx">
      <div ref={dropdownRef}>
        <button type="button" className="hidden w-full items-center justify-center space-x-2 py-2 text-sm font-medium text-gray-700 focus:outline-none md:inline-flex rtl:space-x-reverse" onClick={handleDropdown} aria-label="Open Account Menu">
          <span>
            <IconAvatar className="text-header-icon w-4 fill-current md:w-[20px]" data-sentry-element="IconAvatar" data-sentry-source-file="UserDropdown.jsx" />
          </span>
        </button>
        <button type="button" className="inline-flex w-full items-center justify-center space-x-2 py-2 text-sm font-medium text-gray-700 focus:outline-none md:hidden rtl:space-x-reverse" onClick={handleUserDropdownBottomSheet} aria-label="Open Account Menu">
          <span>
            <IconAvatar className="text-header-icon w-4 fill-current md:w-[20px]" data-sentry-element="IconAvatar" data-sentry-source-file="UserDropdown.jsx" />
          </span>
          <IconPolygon className="hidden md:block" data-sentry-element="IconPolygon" data-sentry-source-file="UserDropdown.jsx" />
        </button>
        <BottomSheet isOpen={isUserDropdownBottomSheetOpen} onClose={handleUserDropdownBottomSheet} title={t("Profile")} variant="auto" data-sentry-element="BottomSheet" data-sentry-source-file="UserDropdown.jsx">
          <DropdownContent onClick={() => {
          setIsOpen(false);
          handleUserDropdownBottomSheet();
        }} data-sentry-element="DropdownContent" data-sentry-source-file="UserDropdown.jsx" />
        </BottomSheet>
        {isOpen && <DropdownContent onClick={() => {
        setIsOpen(false);
      }} />}
      </div>
    </div>;
};
export default UserDropdown;